import getPricingComponentInstance from './js/rankings/components/PricingComponent.js';

async function initPricingPage() {
    console.log('Initializing pricing page');
    const container = document.getElementById('pricing-page-content');
    
    if (!container) {
        console.error('Pricing page content container not found');
        return;
    }

    try {
        // Initialize the pricing component
        const pricingComponent = getPricingComponentInstance(container);
        console.log('Pricing component initialized successfully');
    } catch (error) {
        console.error('Error initializing pricing component:', error);
    }
}

document.addEventListener('DOMContentLoaded', initPricingPage);

export default { initPricingPage };

